import Vue from 'vue'
import axios from 'axios'
import { processRound } from '@/store/modules/rounds/index'

// state
export const state = {
  isRoundsHistoryLoading: false,
  all: {},
}

// getters
export const getters = {
  getHistoryRoundsForSelectedLeague: ({ all }, getters, { 'leagues/index': { selectedLeagueId } }) => all[selectedLeagueId] || [],
}
// mutations
export const mutations = {
  fetchRoundsHistoryStarted(state) {
    state.isRoundsHistoryLoading = true
  },
  fetchRoundsHistorySuccess(state, { rounds, leagueId }) {
    const today = new Date()
    Vue.set(state.all, leagueId, rounds.map(round => processRound(round, today)))
    state.isRoundsHistoryLoading = false
  },
  fetchRoundsHistoryFailed(state) {
    state.isRoundsHistoryLoading = false
  },
}
// actions
export const actions = {
  async fetchRoundsHistory({
    commit,
    state: { all },
    rootState: { 'leagues/index': { selectedLeagueId } },
  }) {
    if (typeof all[selectedLeagueId] !== 'undefined') {
      return all[selectedLeagueId]
    }
    let rounds = null
    try {
      commit('fetchRoundsHistoryStarted')
      rounds = await axios.get(`league/${selectedLeagueId}/historicRounds`)
      commit('fetchRoundsHistorySuccess', {
        rounds,
        leagueId: selectedLeagueId,
      })
    } catch (e) {
      commit('fetchRoundsHistoryFailed')
    }
    return rounds
  },
}
